export default __webpack_public_path__ + "static/media/BasicProgramming2.bc18eb69.png";